import { Action } from '@ngrx/store';
import { File } from '../../_models/file';
import { Workstep } from '../../_models/workstep';

export enum FileActitonTypes {

  ClearFile = '[File] Clear',
  InicializeFile = '[File] Inicialize',

  SetCurrentFile = '[File] Set Current',
  SetCurrentFileId = '[File] Set Current Id',
  SetFilterFields = '[File] Set Filter Fields',
  SetExportedFileName = '[File] Set ExportedFileName',

  LoadFiles = '[File] Get List',
  LoadFilesSuccess = '[File] Load Success',
  LoadFilesFail = '[File] Load Fail',

  UpdateFile = '[File] Update',
  UpdateFileSuccess = '[File] Update Success',
  UpdateFileFail = '[File] Update Fail',

  OptimizerFile = '[File] Optimizer File',
  OptimizerFileSuccess = '[File] Optimizer File Success',
  OptimizerFileFail = '[File] Optimizer File Fail',

  InfoFileList = '[File] Info File List',
  InfoFileListSuccess = '[File] Info File List Success',
  InfoFileListFail = '[File] Info File List Fail',

  CreateFile = '[File] Create',
  CreateFileSuccess = '[File] Create Success',
  CreateFileFail = '[File] Create Fail',

  DeleteFile = '[File] Delete',
  DeleteFileSuccess = '[File] Delete Success',
  DeleteFileFail = '[File] Delete Fail',

  // ---------- FICHEROS
  SendEmail = '[File] Send Email',
  SendEmailSuccess = '[File] Send Email Success',
  SendEmailFail = '[File] Send Email Fail',

  PrintFile = '[File] Print File',
  PrintFileSuccess = '[File] Print File Success',
  PrintFileFail = '[File] Print File Fail',

  MakeCsv = '[File] MakeCsv File',
  MakeCsvSuccess = '[File] MakeCsv File Success',
  MakeCsvFail = '[File] MakeCsv File Fail',

  ReadCsv = '[File] readCsv File',
  ReadCsvSuccess = '[File] readCsv File Success',
  ReadCsvFail = '[File] readCsv File Fail',

  ResetFileList = '[File] Reset FileList',

  UpdateFileCSV = '[File] Update File CSV',
  UpdateFileCSVSuccess = '[File] Update File CSV Success',
  UpdateFileCSVFail = '[File] Update File CSV Fail',

  // ---------- IMPRIMIR PDF
  PrintSheets = '[File] Print Sheets',
  PrintSheetsSuccess = '[File] Print Sheets Success',
  PrintSheetsFail = '[File] Print Sheets Fail',

  PrintEasels = '[File] Print Easels',
  PrintEaselsSuccess = '[File] Print Easels Success',
  PrintEaselsFail = '[File] Print Easels Fail',

  // ---------- PASOS DE TRABAJO EN MESA
  LoadWorksteps = '[File] Load Worksteps',
  LoadWorkstepsSuccess = '[File] Load Worksteps Success',
  LoadWorkstepsFail = '[File] Load Worksteps Fail',

  // ---------- DATOS PIEZAS OPTIMIZACIÓN

  LoadOptiPiece = '[File] Load OptiPiece',
  LoadOptiPieceSuccess = '[File] Load OptiPiece Success',
  LoadOptiPieceFail = '[File] Load OptiPiece Fail',
  
  // ---------- DATOS PIEZAS FLOOR

  LoadPiece = '[File] Load Piece',
  LoadPieceSuccess = '[File] Load Piece Success',
  LoadPieceFail = '[File] Load Piece Fail'
}

export class ClearFile implements Action {
	readonly type = FileActitonTypes.ClearFile;
}

export class InicializeFile implements Action {
	readonly type = FileActitonTypes.InicializeFile;
}

export class SetCurrentFile implements Action {
	readonly type = FileActitonTypes.SetCurrentFile;

	constructor(public payload: File) {}
}

export class SetCurrentFileId implements Action {
	readonly type = FileActitonTypes.SetCurrentFileId;

	constructor(public payload: bigint) {}
}

export class SetFilterFields implements Action {
	readonly type = FileActitonTypes.SetFilterFields;

	constructor(public payload: any) {}
}

export class SetExportedFileName implements Action {
	readonly type = FileActitonTypes.SetExportedFileName;

	constructor(public payload: File) {}
}

export class LoadFiles implements Action {
	readonly type = FileActitonTypes.LoadFiles;

	constructor(public payload: any) {}
}

export class LoadFilesSuccess implements Action {
	readonly type = FileActitonTypes.LoadFilesSuccess;

	constructor(public payload: File[]) {}
}

export class LoadFilesFail implements Action {
	readonly type = FileActitonTypes.LoadFilesFail;

	constructor(public payload: string) {}
}

export class UpdateFile implements Action {
	readonly type = FileActitonTypes.UpdateFile;

	constructor(public payload: File) {}
}

export class UpdateFileSuccess implements Action {
	readonly type = FileActitonTypes.UpdateFileSuccess;

	constructor(public payload: File) {}
}

export class UpdateFileFail implements Action {
	readonly type = FileActitonTypes.UpdateFileFail;

	constructor(public payload: string) {}
}

export class OptimizerFile implements Action {
	readonly type = FileActitonTypes.OptimizerFile;

	constructor(public payload: any) {}
}

export class OptimizerFileSuccess implements Action {
	readonly type = FileActitonTypes.OptimizerFileSuccess;

	constructor(public payload: any) {}
}

export class OptimizerFileFail implements Action {
	readonly type = FileActitonTypes.OptimizerFileFail;

	constructor(public payload: string) {}
}

export class InfoFileList implements Action {
	readonly type = FileActitonTypes.InfoFileList;

	constructor(public payload: any) {}
}

export class InfoFileListSuccess implements Action {
	readonly type = FileActitonTypes.InfoFileListSuccess;

	constructor(public payload: any) {}
}

export class InfoFileListFail implements Action {
	readonly type = FileActitonTypes.InfoFileListFail;

	constructor(public payload: string) {}
}

export class DeleteFile implements Action {
	readonly type = FileActitonTypes.DeleteFile;

	constructor(public payload: File) {}
}

export class DeleteFileSuccess implements Action {
	readonly type = FileActitonTypes.DeleteFileSuccess;

	constructor(public payload: bigint) {}
}

export class DeleteFileFail implements Action {
	readonly type = FileActitonTypes.DeleteFileFail;

	constructor(public payload: string) {}
}

export class CreateFile implements Action {
	readonly type = FileActitonTypes.CreateFile;

	constructor(public payload: File) {}
}

export class CreateFileSuccess implements Action {
	readonly type = FileActitonTypes.CreateFileSuccess;

	constructor(public payload: File) {}
}

export class CreateFileFail implements Action {
	readonly type = FileActitonTypes.CreateFileFail;

	constructor(public payload: string) {}
}

// --------- PASOS DE TRABAJO -----------------
export class LoadWorksteps implements Action {
	readonly type = FileActitonTypes.LoadWorksteps;

	constructor(public payload: any) {}
}

export class LoadWorkstepsSuccess implements Action {
	readonly type = FileActitonTypes.LoadWorkstepsSuccess;

	constructor(public payload: Workstep[]) {}
}

export class LoadWorkstepsFail implements Action {
	readonly type = FileActitonTypes.LoadWorkstepsFail;

	constructor(public payload: string) {}
}

// --------- EMAIL ----------
export class SendEmail implements Action {
	readonly type = FileActitonTypes.SendEmail;

	constructor(public payload: any) {}
}

export class SendEmailSuccess implements Action {
	readonly type = FileActitonTypes.SendEmailSuccess;

	constructor(public payload: any) {}
}

export class SendEmailFail implements Action {
	readonly type = FileActitonTypes.SendEmailFail;

	constructor(public payload: string) {}
}

// --------- PRINT ----------
export class PrintFile implements Action {
	readonly type = FileActitonTypes.PrintFile;

	constructor(public payload: any) {}
}

export class PrintFileSuccess implements Action {
	readonly type = FileActitonTypes.PrintFileSuccess;

	constructor(public payload: any) {}
}

export class PrintFileFail implements Action {
	readonly type = FileActitonTypes.PrintFileFail;

	constructor(public payload: string) {}
}

export class PrintSheets implements Action {
	readonly type = FileActitonTypes.PrintSheets;

	constructor(public payload: any) {}
}

export class PrintSheetsSuccess implements Action {
	readonly type = FileActitonTypes.PrintSheetsSuccess;

	constructor(public payload: any) {}
}

export class PrintSheetsFail implements Action {
	readonly type = FileActitonTypes.PrintSheetsFail;

	constructor(public payload: string) {}
}

export class PrintEasels implements Action {
	readonly type = FileActitonTypes.PrintEasels;

	constructor(public payload: any) {}
}

export class PrintEaselsSuccess implements Action {
	readonly type = FileActitonTypes.PrintEaselsSuccess;

	constructor(public payload: any) {}
}

export class PrintEaselsFail implements Action {
	readonly type = FileActitonTypes.PrintEaselsFail;

	constructor(public payload: string) {}
}

// --------- MAKE CSV ----------
export class MakeCsv implements Action {
	readonly type = FileActitonTypes.MakeCsv;

	constructor(public payload: any) {}
}

export class MakeCsvSuccess implements Action {
	readonly type = FileActitonTypes.MakeCsvSuccess;

	constructor(public payload: any) {}
}

export class MakeCsvFail implements Action {
	readonly type = FileActitonTypes.MakeCsvFail;

	constructor(public payload: string) {}
}

// --------- READ CSV ----------
export class ReadCsv implements Action {
	readonly type = FileActitonTypes.ReadCsv;

	constructor(public payload: any) {}
}

export class ReadCsvSuccess implements Action {
	readonly type = FileActitonTypes.ReadCsvSuccess;

	constructor(public payload: any) {}
}

export class ReadCsvFail implements Action {
	readonly type = FileActitonTypes.ReadCsvFail;

	constructor(public payload: string) {}
}

export class ResetFileList implements Action {
	readonly type = FileActitonTypes.ResetFileList;
}

// ----------- FILE CSV

export class UpdateFileCSV implements Action {
	readonly type = FileActitonTypes.UpdateFileCSV;

	constructor(public payload: any) {}
}

export class UpdateFileCSVSuccess implements Action {
	readonly type = FileActitonTypes.UpdateFileCSVSuccess;

	constructor(public payload: any) {}
}

export class UpdateFileCSVFail implements Action {
	readonly type = FileActitonTypes.UpdateFileCSVFail;

	constructor(public payload: string) {}
}

// ---------- DATOS PIEZAS OPTIMIZACIÓN

export class LoadOptiPiece implements Action {
	readonly type = FileActitonTypes.LoadOptiPiece;

	constructor(public payload: File) {}
}

export class LoadOptiPieceSuccess implements Action {
	readonly type = FileActitonTypes.LoadOptiPieceSuccess;

	constructor(public payload: File) {}
}

export class LoadOptiPieceFail implements Action {
	readonly type = FileActitonTypes.LoadOptiPieceFail;

	constructor(public payload: string) {}
}

// ---------- DATOS PIEZAS FLOOR

export class LoadPiece implements Action {
	readonly type = FileActitonTypes.LoadPiece;

	constructor(public payload: File) {}
}

export class LoadPieceSuccess implements Action {
	readonly type = FileActitonTypes.LoadPieceSuccess;

	constructor(public payload: File) {}
}

export class LoadPieceFail implements Action {
	readonly type = FileActitonTypes.LoadPieceFail;

	constructor(public payload: string) {}
}

// Unión de acciones
export type FileActions = ClearFile
| InicializeFile
| SetCurrentFile
| SetCurrentFileId
| SetFilterFields
| SetExportedFileName
| LoadFiles
| LoadFilesSuccess
| LoadFilesFail
| LoadWorksteps
| LoadWorkstepsSuccess
| LoadWorkstepsFail
| UpdateFile
| UpdateFileSuccess
| UpdateFileFail
| OptimizerFile
| OptimizerFileSuccess
| OptimizerFileFail
| InfoFileList
| InfoFileListSuccess
| InfoFileListFail
| CreateFile
| CreateFileSuccess
| CreateFileFail
| DeleteFile
| DeleteFileSuccess
| DeleteFileFail
| SendEmail
| SendEmailSuccess
| SendEmailFail
| PrintFile
| PrintFileSuccess
| PrintFileFail
| PrintSheets
| PrintSheetsSuccess
| PrintSheetsFail
| PrintEasels
| PrintEaselsSuccess
| PrintEaselsFail
| MakeCsv
| MakeCsvSuccess
| MakeCsvFail
| ReadCsv
| ReadCsvSuccess
| ReadCsvFail
| ResetFileList
| UpdateFileCSV
| UpdateFileCSVSuccess
| UpdateFileCSVFail
| LoadOptiPiece
| LoadOptiPieceSuccess
| LoadOptiPieceFail
| LoadPiece
| LoadPieceSuccess
| LoadPieceFail;
